module.exports = __webpack_public_path__ + "static/img/14000612.bef6e0e1.png";